import React from "react";

const YoungEarnersUnder = (props) => {
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between pt-5">
          <div className="col-lg-12">
            <ul className="list-unstyled gap-3 d-flex flex-column">
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
              >
                <h5 className="title_text text-dark">
                  1. Rewards for customers under 18
                </h5>
                <ul className="info_description text-dark opacity-50">
                  <li>
                    TopCoin UK is open to customers of all ages. We believe in
                    rewarding loyalty for everyone, including young customers.
                    However, when it comes to releasing any cash-equivalent
                    rewards from unlocked wallets, we follow a clear and
                    responsible policy.
                  </li>
                </ul>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">2. Participation</h5>
                <ul className="info_description text-dark opacity-50">
                  <li>
                    Customers under the age of 18 can collect TopCoin UK, unlock
                    loyalty milestones, and receive reward benefits.
                  </li>
                  <li>
                    Participation requires a parent or guardian’s consent during
                    account registration.
                  </li>
                </ul>
              </li>

              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
              >
                <h5 className="title_text text-dark">
                  3. Receiving Cash Rewards
                </h5>
                <p className="info_description text-dark opacity-50 fw-bold mb-0">
                  When a customer under 18 unlocks a reward wallet, they have
                  two options:
                </p>
                <p>
                  <p className="info_description mt-2 text-dark opacity-50 fw-bold mb-0">
                    Option A – Payment to Their Own Bank Account
                  </p>
                  <ul className="info_description my-3 text-dark opacity-50">
                    <li>
                      If the customer holds a valid UK youth bank account in
                      their own name, TopCoin UK can transfer the reward value
                      to that account.{" "}
                    </li>
                    <li>
                      {" "}
                      The customer (or their parent/guardian) must ensure the
                      bank account details provided are correct.{" "}
                    </li>
                    <li>
                      {" "}
                      Youth bank accounts may have their own limits or
                      conditions set by the bank.
                    </li>
                  </ul>
                  <p className="info_description text-dark opacity-50 fw-bold mb-0">
                    Option B – Payment to Parent/Guardian Bank Account
                  </p>
                  <ul className="info_description text-dark opacity-50">
                    <li>
                      If the customer does not have their own bank account, or
                      chooses this option, rewards can be transferred to the
                      parent/guardian’s nominated UK bank account.
                    </li>
                  </ul>
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
              >
                <h5 className="title_text text-dark">
                  4. Consent & Verification
                </h5>

                <ul className="info_description text-dark opacity-50">
                  <li>
                    For all payments to customers under 18, TopCoin UK requires parental or guardian consent.
                  </li>
                  <li>
                    Proof of identity may be required for both the customer and the parent/guardian before releasing funds, to ensure responsible participation and child safeguarding.
                  </li>
                </ul>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
              >
                <h5 className="title_text text-dark"> 5. Responsibility </h5>

                <ul className="info_description text-dark opacity-50">
                  <li>
                    TopCoin UK only holds reward balances temporarily until the approved payment method is confirmed.
                  </li>
                  <li>
                    We are a rewards and loyalty platform, not a bank, investment platform, savings product, or gambling service.
                  </li>
                  <li>
                    Rewards do not earn interest and are not treated as financial deposits.
                    </li>
                </ul>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
              >
                <h5 className="title_text text-dark">
                  6. Cashing for individuals under 18{" "}
                </h5>

                <ul className="info_description text-dark opacity-50">
                  <li>
                    Customers under 18 are welcome to collect TopCoin, unlock milestones, and receive rewards.
                  </li>
                  <li>
                    When cashing out from a reward wallet, parental or guardian consent is required to ensure responsible participation.

                  </li>
                </ul>
                <a
                  href="../../../parental_consent_form.pdf"
                  download
                  className=" fw-bold text-decoration-underline text-primary"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  Download the parental /guardian content form{" "}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default YoungEarnersUnder;
